import { tokens } from 'src/design-system';

export const SEQuotePanelStyles = () => ({
  loader: {
    width: '100%',
    textAlign: 'center',
    padding: tokens.spacing.lg,
  },
  errorText: {
    color: tokens.colors.error,
    fontSize: tokens.fontSize.small,
    padding: tokens.spacing.sm,
  },
  // ISS-293278 — the Spot/Tender rate-source toggle bar, pinned at the top of the tab. `marginRight` on the
  // label (not flex `gap`, which this react-jss/browser combo drops — the cause of the overlapping text)
  // guarantees a gap between the label and the buttons.
  rateToggle: {
    display: 'flex',
    alignItems: 'center',
    padding: `${tokens.spacing.sm}px ${tokens.spacing.ms}px`,
    marginBottom: tokens.spacing.md,
    backgroundColor: tokens.colors.bgSubtle,
    borderRadius: tokens.radius.md,
  },
  rateToggleLabel: {
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
    marginRight: tokens.spacing.ms,
    whiteSpace: 'nowrap',
  },
  // Component width (not a spacing token) so the RFQ names are readable; grows with the label bar.
  rfqSelect: {
    minWidth: 220,
  },
  // Advisory banner, not error text: the warning token is a bright yellow that is unreadable as a
  // foreground colour, so it drives the accent border while the pale highlight carries the background.
  warningText: {
    color: tokens.colors.text,
    backgroundColor: tokens.colors.highlightYellow,
    borderLeft: `${tokens.spacing.xxs}px solid ${tokens.colors.warning}`,
    borderRadius: tokens.radius.sm,
    fontSize: tokens.fontSize.small,
    padding: tokens.spacing.sm,
    marginBottom: tokens.spacing.sm,
  },
});
